// This module will require the index view and will render it in a root node
// It will probably be replaced by the index redux which will provide the state
import { createRoot } from 'react-dom/client';

import IndexView from './index_view';
import initApp from './init_app';

document.addEventListener('DOMContentLoaded', () => {
  initApp();

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<IndexView />);
});
